import BossModel from "@/models/BossModel";
import Element from "@/models/WebsitePage/Version/Element/Element";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Container extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-page/version/container';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePageVersionContainers';

    static fields() {
		return {
			id: this.number(null).nullable(),
			rank: this.number(null).nullable(),
			color: this.attr(null),
			website_page_version_id: this.number(null).nullable(),
            website_filter_page_id: this.number(null).nullable(),
			website_news_page_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			is_margin_top_negative: this.boolean(null),
			left_public_image_id: this.number(null).nullable(),
			right_public_image_id: this.number(null).nullable(),
            elements: this.hasMany(Element, 'website_page_version_container_id'),
            leftPublicImage: this.belongsTo(PublicImage, 'left_public_image_id'),
            rightPublicImage: this.belongsTo(PublicImage, 'right_public_image_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static getSelected() {
        return this.all().filter(item => item.copy_selected);
    }

    /**
     *
     * @param container
     * @param rows
     */
    static updateElementRanks(container, rows) {
        for (let key in rows) {
            if (Object.prototype.hasOwnProperty.call(rows, key) && rows[key].id !== undefined) {
                rows[key].rank = key;
                rows[key].website_page_version_container_id = container.id;
                rows[key].website_page_version_element_row_column_id = null;
                rows[key].api().update();
            }
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Elements() {
        return this.getRelated('elements');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    LeftPublicImage() {
        return this.getRelated('leftPublicImage');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    RightPublicImage() {
        return this.getRelated('rightPublicImage');
    }
}
